var map = {
	"./accounting/_subrouter.js": 4114,
	"./dashboard/_subrouter.js": 8597,
	"./master/customer/_subrouter.js": 8742,
	"./master/product/_subrouter.js": 6849,
	"./master/project/_subrouter.js": 6515,
	"./payable/_subrouter.js": 3902,
	"./print/_subrouter.js": 4329,
	"./profile/_subrouter.js": 1493,
	"./quotation/_subrouter.js": 687,
	"./receivable/_subrouter.js": 8328,
	"./report/_subrouter.js": 3503,
	"ui/screens/authorized/accounting/_subrouter.js": 4114,
	"ui/screens/authorized/dashboard/_subrouter.js": 8597,
	"ui/screens/authorized/master/customer/_subrouter.js": 8742,
	"ui/screens/authorized/master/product/_subrouter.js": 6849,
	"ui/screens/authorized/master/project/_subrouter.js": 6515,
	"ui/screens/authorized/payable/_subrouter.js": 3902,
	"ui/screens/authorized/print/_subrouter.js": 4329,
	"ui/screens/authorized/profile/_subrouter.js": 1493,
	"ui/screens/authorized/quotation/_subrouter.js": 687,
	"ui/screens/authorized/receivable/_subrouter.js": 8328,
	"ui/screens/authorized/report/_subrouter.js": 3503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4425;